import { render } from "./VUEPopupEsportaXLSXStorici.vue?vue&type=template&id=3600e950"
import script from "./VUEPopupEsportaXLSXStorici.vue?vue&type=script&lang=js"
export * from "./VUEPopupEsportaXLSXStorici.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__